import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer-contact-container" }
const _hoisted_2 = { class: "footer-contact-description" }
const _hoisted_3 = { class: "footer-contact-title" }
const _hoisted_4 = { class: "footer-contact-subtitle" }
const _hoisted_5 = { class: "footer-contact-types" }
const _hoisted_6 = { class: "footer-contact-type-container" }
const _hoisted_7 = { class: "footer-contact-type-paragraph footer-contact-type-paragraph-phone" }
const _hoisted_8 = { class: "footer-contact-type-container" }
const _hoisted_9 = { class: "footer-contact-type-paragraph footer-contact-type-paragraph-address" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("footer.contact.contact-us")), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("footer.contact.comfortable-way")), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "footer-contact-image footer-contact-image-phone" }, null, -1)),
        _createElementVNode("h4", _hoisted_7, [
          _createTextVNode(_toDisplayString(_ctx.$t("footer.contact.phone1")) + " ", 1),
          _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("footer.contact.phone2")), 1)
        ])
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "footer-contact-type-container" }, [
        _createElementVNode("div", { class: "footer-contact-image footer-contact-image-email" }),
        _createElementVNode("a", { href: "mailto:biuro@exive.pl" }, [
          _createElementVNode("h4", { class: "footer-contact-type-paragraph footer-contact-type-paragraph-email" }, " biuro@exive.pl ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_8, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "footer-contact-image footer-contact-image-address" }, null, -1)),
        _createElementVNode("h4", _hoisted_9, [
          _createTextVNode(_toDisplayString(_ctx.$t("footer.contact.address-line-1")) + " ", 1),
          _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("footer.contact.address-line-2")), 1)
        ])
      ])
    ])
  ]))
}